import i18n from 'i18next';

export const buttonConfig = (settings, enableDisplay) => {
    return {
        label: settings.buttonText,
        url: '',
        textColor: settings.buttonTextColor,
        bgColor: settings.buttonBgColor,
        enableDisplay: enableDisplay
    };
};

export const getDescription = (
    enableLineLiff,
    previewSettings,
    referralCode,
    referralLink,
    isOringalShare
) => {
    const referralCodeText = referralCode
        ? `${i18n.t('label.referral_code')} ${referralCode}` + (referralLink ? '，' : '')
        : '';
    const referralLinkText = referralLink
        ? `${i18n.t('label.mgm_mission_link')} ${isOringalShare ? '' : referralLink}`
        : '';
    return enableLineLiff
        ? previewSettings.invitationDesc
        : `${previewSettings.invitationTitle}
${previewSettings.invitationDesc}

${referralCodeText}${referralLinkText}
`;
};
